import { render, staticRenderFns } from "./PunchFacilityForm.vue?vue&type=template&id=b06d41cc"
import script from "./PunchFacilityForm.vue?vue&type=script&lang=ts"
export * from "./PunchFacilityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports